import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
// import api from "../../api/Api.js";
import api, { IMAGE_BASE_URL } from "../../api/Api.js";
const PageManage = () => {
const imagePath = `${IMAGE_BASE_URL}/uploads/blogs/`;
  // =========================
  // STATES
  // =========================
  const [pageDataTitle, setpageDataTitle] = useState("");
  const [pageDataDesc, setpageDataDesc] = useState("");
    const [getpageMetaTitle, setpageMetaTitle] = useState("");
      const [getpageMetaDesc, setpageMetaDesc] = useState("");
        const [getpageMetaKey, setpageMetaKey] = useState("");
        const [getpageImage, setpageImage] = useState("");
  const [pageId] = useState(2);

  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  // =========================
  // FETCH PAGE DATA
  // =========================

  useEffect(() => {
    fetchPageData();
  }, []);

  const fetchPageData = async () => {

    try {

      const res = await api.get(
        "/adminAllpage/allPagedata",
        {
          params: { pageId }
        }
      );

      console.log(res.data);

      const pageDetails = res.data?.data?.[0];

      if (pageDetails) {

        setpageDataTitle(pageDetails.page_name);
        setpageDataDesc(pageDetails.page_desc);
        setpageMetaTitle(pageDetails.meta_title);
        setpageMetaDesc(pageDetails.meta_desc);
        setpageMetaKey(pageDetails.meta_keyword);
         setpageImage(pageDetails.page_img);
      }

    } catch (error) {

      console.log(error);

      toast.error("Failed to load Pages data");
    }
  };

  // =========================
  // UPDATE PAGE
  // =========================

  const handleUpdatePage = async () => {
  try {
    setLoading(true);

    const formData = new FormData();

    formData.append("pageId", pageId);
    formData.append("page_name", pageDataTitle);
    formData.append("page_desc", pageDataDesc);
    formData.append("meta_title", getpageMetaTitle);
    formData.append("meta_desc", getpageMetaDesc);
    formData.append("meta_keyword", getpageMetaKey);

    if (getpageImage instanceof File) {
      formData.append("pageImage", getpageImage);
    }

    const res = await api.put(
      "/adminAllpage/updatePageVisa",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (res.data.success) {
      toast.success("Page updated successfully");
      setIsEditing(false);
      fetchPageData();
    }
  } catch (error) {
    console.log(error);
    toast.error("Failed to update page");
  } finally {
    setLoading(false);
  }
};

  // =========================
  // JSX
  // =========================

  return (

    <div
      className="container-fluid py-4 min-vh-100"
      style={{
        background: "#f4f7fb",
      }}
    >

      {/* PAGE HEADER */}
      <div className="row mb-4">

        <div className="col-12">

          <div
            className="card border-0 shadow-lg rounded-4 overflow-hidden"
          >

            <div
              className="card-body p-4"
              style={{
                background:
                  "linear-gradient(135deg, #4f46e5, #7c3aed)",
              }}
            >

              <div className="d-flex justify-content-between align-items-center">

                <div>

                  <h2 className="text-white fw-bold mb-1">
                    Manage Page
                  </h2>

                  <p className="text-light mb-0 small">
                    View and manage page details
                  </p>

                </div>

                {/* ACTION BUTTONS */}
                <div className="d-flex gap-2">

                  {!isEditing ? (

                    <button
                      className="btn btn-light px-4 py-2 fw-semibold rounded-pill shadow-sm"
                      onClick={() => setIsEditing(true)}
                    >
                      <i className="fa fa-pencil me-2"></i>
                      Edit Page
                    </button>

                  ) : (

                    <>
                      <button
                        className="btn btn-success px-4 py-2 fw-semibold rounded-pill"
                        onClick={handleUpdatePage}
                        disabled={loading}
                      >
                        {loading ? "Updating..." : "Save Changes"}
                      </button>

                      <button
                        className="btn btn-danger px-4 py-2 fw-semibold rounded-pill"
                        onClick={() => {
                          setIsEditing(false);
                          fetchPageData();
                        }}
                      >
                        Cancel
                      </button>
                    </>

                  )}

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* CONTENT CARD */}
      <div className="row">

        <div className="col-lg-12 mx-auto">

          <div
            className="card border-0 shadow-sm rounded-4"
            style={{
              background: "#ffffff",
            }}
          >

            <div className="card-body p-4">

              {pageDataTitle === "" ? (

                <div className="text-center py-5">

                  <img
                    src="https://cdn-icons-png.flaticon.com/512/7486/7486740.png"
                    alt="No Data"
                    width="120"
                    className="mb-3 opacity-75"
                  />

                  <h5 className="fw-bold text-secondary">
                    No Page Data Found
                  </h5>

                  <p className="text-muted">
                    There is currently no page information available.
                  </p>

                </div>

              ) : (

                <div className="row g-4">

                  {/* PAGE NAME */}
                  <div className="col-12">

                    <div
                      className="p-4 rounded-4 border"
                      style={{
                        background: "#f8fafc",
                      }}
                    >

                      <label
                        className="text-uppercase fw-bold small mb-2 d-block"
                        style={{
                          color: "#6366f1",
                          letterSpacing: "1px",
                        }}
                      >
                        Page Name
                      </label>

                      {isEditing ? (

                        <input
                          type="text"
                          className="form-control form-control-lg rounded-3"
                          value={pageDataTitle}
                          onChange={(e) =>
                            setpageDataTitle(e.target.value)
                          }
                        />

                      ) : (

                        <h4 className="fw-bold text-dark mb-0">
                          {pageDataTitle}
                        </h4>

                      )}

                    </div>

                  </div>

  {/* Meta Title */}
                  <div className="col-12">

                    <div
                      className="p-4 rounded-4 border"
                      style={{
                        background: "#f8fafc",
                      }}
                    >

                     <div className="d-flex align-items-center gap-2">
                        <span     className="text-uppercase fw-bold small d-block"
                        style={{
                          color: "#6366f1",
                          letterSpacing: "1px",
                        }}>Meta Title</span>
                        <small className={`d-block  ${
                           (getpageMetaTitle?.length || 0) > 80 ? "text-danger" : "text-muted"
                        }`}>
                        ({(getpageMetaTitle?.length || 0)}/80 Characters)
                        </small>
                     </div>

                      {isEditing ? (

                        <textarea
                          rows="4"
                          maxLength={80} 
                          className="form-control rounded-4"
                          value={getpageMetaTitle}
                          onChange={(e) =>
                            setpageMetaTitle(e.target.value)
                          }
                        />

                      ) : (

                        <p
                          className="text-secondary mb-0"
                          style={{
                            lineHeight: "1.9",
                            fontSize: "15px",
                          }}
                        >
                          {getpageMetaTitle}
                        </p>

                      )}

                    </div>

                  </div>

                  
  {/* Meta description */}
                  <div className="col-12">

                    <div
                      className="p-4 rounded-4 border"
                      style={{
                        background: "#f8fafc",
                      }}
                    >

                  <div className="d-flex align-items-center gap-2">
                        <span  className="text-uppercase fw-bold small  d-block"
                        style={{
                          color: "#6366f1",
                          letterSpacing: "1px",
                        }}>Meta Description</span>
                        <small className={`d-block  ${
                           (getpageMetaDesc?.length  || 0)> 160 ? "text-danger" : "text-muted"
                        }`}>
                        ({(getpageMetaDesc?.length || 0)}/160 Characters)
                        </small>
                     </div>

                      {isEditing ? (

                        <textarea
                          rows="4"
                          maxLength={160} 
                          className="form-control rounded-4"
                          value={getpageMetaDesc}
                          onChange={(e) =>
                            setpageMetaDesc(e.target.value)
                          }
                        />

                      ) : (

                        <p
                          className="text-secondary mb-0"
                          style={{
                            lineHeight: "1.9",
                            fontSize: "15px",
                          }}
                        >
                          {getpageMetaDesc}
                        </p>

                      )}

                    </div>

                  </div>

                  
  {/* Meta key */}
                  <div className="col-12">

                    <div
                      className="p-4 rounded-4 border"
                      style={{
                        background: "#f8fafc",
                      }}
                    >

                    <div className="d-flex align-items-center gap-2">
               <span  className="text-uppercase fw-bold small  d-block"
                        style={{
                          color: "#6366f1",
                          letterSpacing: "1px",
                        }}>Meta Keyword  </span><small className={`d-block  ${
                  (getpageMetaKey?.length || 0 )> 255 ? "text-danger" : "text-muted"
               }`}>
               ({(getpageMetaKey?.length || 0 )}/255 Characters)
               </small>
               </div>

                      {isEditing ? (

                        <textarea
                          rows="4"
                          maxLength={255} 
                          className="form-control rounded-4"
                          value={getpageMetaKey}
                          onChange={(e) =>
                            setpageMetaKey(e.target.value)
                          }
                        />

                      ) : (

                        <p
                          className="text-secondary mb-0"
                          style={{
                            lineHeight: "1.9",
                            fontSize: "15px",
                          }}
                        >
                          {getpageMetaKey}
                        </p>

                      )}

                    </div>

                  </div>


                  {/* PAGE DESCRIPTION */}
                  <div className="col-12">

                    <div
                      className="p-4 rounded-4 border"
                      style={{
                        background: "#f8fafc",
                      }}
                    >

                      <label
                        className="text-uppercase fw-bold small mb-3 d-block"
                        style={{
                          color: "#6366f1",
                          letterSpacing: "1px",
                        }}
                      >
                        Page Description
                      </label>

                      {isEditing ? (

                        <textarea
                          rows="8"
                          className="form-control rounded-4"
                          value={pageDataDesc}
                          onChange={(e) =>
                            setpageDataDesc(e.target.value)
                          }
                        />

                      ) : (

                        <p
                          className="text-secondary mb-0"
                          style={{
                            lineHeight: "1.9",
                            fontSize: "15px",
                          }}
                        >
                          {pageDataDesc}
                        </p>

                      )}

                    </div>

                  </div>

                  
                  {/* PAGE IMAGE */}
                  <div className="col-12">

                    <div
                      className="p-4 rounded-4 border"
                      style={{
                        background: "#f8fafc",
                      }}
                    >

                      <label
                        className="text-uppercase fw-bold small mb-3 d-block"
                        style={{
                          color: "#6366f1",
                          letterSpacing: "1px",
                        }}
                      >
                        Page Image 
                      </label>

                      {isEditing ? (

                      <input
  type="file"
  className="form-control rounded-4"
  onChange={(e) => setpageImage(e.target.files[0])}
/>

                      ) : (
                        <>
<img
  // src={getpageImage}
     src={`${imagePath}${getpageImage}`}
  style={{ width: "100%" }}
  alt="Page"

/>
                       
                       </>
                          
                     

                      )}

                    </div>

                  </div>

                </div>

              )}

            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default PageManage;